import React, { useState } from "react";
//import { useForm } from "../../../hooks/useForm";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@material-ui/core";
import { ValidatorForm } from "react-material-ui-form-validator";
import { EMPADRONAMIENTO_SOLICITUDES_ESTADOS, STEPPER_EMPADRONAMIENTO } from "../../../utils/constants";
import {
  confirmarSolicitud,
  setActiveStep,
  setShowForm,
} from "../../../actions/empadronamiento/Empadronamiento";
import { EmpadronamientoAccordionDocumentacion } from "./Accordions/EmpadronamientoAccordionDocumentacion";
import { EMPADRONAMIENTO_MENU_PERMISOS } from "../../../utils/permisos";
import { validarSoloUnPermiso } from "../../../helpers/permisos";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

export const EmpadronamientoDetalleSolicitudDocumentacion = (props) => {
  const dispatch = useDispatch();
  const { solicitudSeleccionada } = useSelector((state) => state.empadronamiento);
  const [datosCompletosDocumentacion, setDatosCompletosDocumentacion] = useState(false);
  const { permisos: permisosUser } = useSelector((state) => state.auth);
  const [redirect, setRedirect] = useState(false);

  let idSolicitud = 0;
  let idEstadoSolicitud = 0;

  if (!!solicitudSeleccionada) {
    idSolicitud = solicitudSeleccionada?.idSolicitud;
    idEstadoSolicitud = solicitudSeleccionada?.idEstadoSolicitud;
  }
  /*
  const [
    formValues,
    ,
    ,
    setearValor,
    ,
    ,
    ,
    ,
    ,
  ] = useForm(
    solicitudSeleccionada
  );

  const {
    fechaInicio = new Date()
  } = formValues;
  */

  const submitHandler = () => {
    dispatch(confirmarSolicitud(idSolicitud,
      false,
      (idEstadoSolicitud === EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_AUTORIZACION ||
        validarSoloUnPermiso(
          permisosUser,
          EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
        ) || validarSoloUnPermiso(
          permisosUser,
          EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
        )),
      setRedirect,
      validarSoloUnPermiso(
        permisosUser,
        EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
      ),
      validarSoloUnPermiso(
        permisosUser,
        EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
      ),
      validarSoloUnPermiso(
        permisosUser,
        EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
      )));
  };

  return (
    <React.Fragment>
      <ValidatorForm onSubmit={submitHandler}>
        <EmpadronamientoAccordionDocumentacion
          datosCompletos={datosCompletosDocumentacion}
          setDatosCompletos={setDatosCompletosDocumentacion}
          idTipoEmpadronamiento={props.idTipoEmpadronamiento}
          idPatologia={props.idPatologia}
        />

        <div
          style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
        >
          <Button
            variant="contained"
            color="secondary"
            style={{ marginRight: "3rem" }}
            onClick={() => {
              dispatch(setActiveStep(STEPPER_EMPADRONAMIENTO.DETALLE));
              dispatch(setShowForm(false));
            }}
          >
            Anterior
          </Button>
          <Button variant="contained" color="primary" type="submit" disabled={!datosCompletosDocumentacion}>
            Finalizar
          </Button>
        </div>
      </ValidatorForm>
      {

        redirect &&
        <Redirect
          to={{
            pathname: "/:programa/empadronamiento",
          }}
        />
      }

    </React.Fragment>
  );
};
